<template>
  <div class="controller-awards">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tiêu đề" prop="title">
          <a-input v-model="form.title" placeholder="Tiêu đề" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Nội dung" prop="content">
          <a-textarea :rows="5" v-model="form.content" placeholder="Nội dung" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Ngày nhận" prop="award_date">
          <a-date-picker
            v-model="form.award_date"
            class="w-full"
            placeholder="Ngày nhận"
          />
        </a-form-model-item>
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  fetchById,
  updateAwards,
  createAwards,
} from "@/services/landing-page/about-us";
import dayjs from "dayjs";
export default {
  name: "ControllerAwards",
  data() {
    return {
      callingAPI: false,
      form: {
        title: "",
        description: "",
        content: "",
        award_date: "",
        active: 1,
        type: 2,
        post_type: 2,
      },
      rules: {
        title: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        content: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        award_date: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        const response = await fetchById(this.$route.params.id);
        this.form.title = response.data.title;
        this.form.content = response.data.content;
        this.form.award_date = response.data.award_date;
        this.form.active = response.data.active;
      } catch (error) {}
    },

    async handleSubmit() {
      try {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            try {
              this.callingAPI = true;
              const data = {
                ...this.form,
                award_date: dayjs(this.form.award_date).format("DD/MM/YYYY"),
              };
              let message;
              if (this.$route.params.id) {
                data._method = "PUT";
                await updateAwards(this.$route.params.id, data);
              } else {
                await createAwards(data);
              }
              this.callingAPI = false;
              message = this.$route.params.id
                ? "Cập nhật thành công"
                : "Thêm mới thành công";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
              this.$router.push({ name: "ManageAwardsArchievements" });
            } catch (error) {
              let message = this.$route.params.id
                ? "Cập nhật thất bại"
                : "Thêm mới thất bại";
              this.$notification.error({
                message: "Thất bại",
                description: message,
              });
            }
          }
        });
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
</style>